export default "__VITE_ASSET__DE5LE0W4__"